import LogoFullWhiteT from "./img/psikku-w.png";
import LogoFullColorT from "./img/logo-full.png";
import LogoPColorT from "./img/logo-c1.png";
import LogoPWhiteT from "./img/logo-c2.png";

export const LogoFullWhite = ({ className }) => (
  <img src={LogoFullWhiteT} className={className} />
);
export const LogoFullColor = ({ className }) => (
  <img src={LogoFullColorT} className={className} />
);

export const LogoPColor = ({ className }) => (
  <img src={LogoPColorT} className={className} />
);
export const LogoPWhite = ({ className }) => (
  <img src={LogoPWhiteT} className={className} />
);
